var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0298 18.3999V13.6C25.0298 12.6452 24.6608 11.7295 24.0039 11.0544C23.3471 10.3793 22.4561 10 21.5272 10L16.8569 20.7999V33.9998H30.027C30.5901 34.0064 31.1366 33.8035 31.5657 33.4287C31.9948 33.0538 32.2777 32.5321 32.3621 31.9599L33.9733 21.1599C34.0241 20.816 34.0016 20.4648 33.9072 20.1306C33.8128 19.7965 33.6489 19.4875 33.4268 19.225C33.2046 18.9624 32.9296 18.7527 32.6208 18.6102C32.312 18.4678 31.9767 18.396 31.6382 18.3999H25.0298Z",
    stroke: "#30426D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22.2856C10 21.1811 10.8954 20.2856 12 20.2856H16.8571V33.9999H12C10.8954 33.9999 10 33.1045 10 31.9999V22.2856Z",
    fill: "#30426D",
    stroke: "#30426D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiked);
export default __webpack_public_path__ + "static/media/liked.91ea7123122976ce44ad6c12341107ae.svg";
export { ForwardRef as ReactComponent };